import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NeoExpansionModule } from '@neogov/pattern-library/neo-expansion-panel';

@Component({
  selector: 'cm-expansion-panel',
  standalone: true,
  imports: [CommonModule, NeoExpansionModule],
  templateUrl: './expansion-panel.component.html',
  styleUrl: './expansion-panel.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpansionPanelComponent {
  public readonly title = input<string>('');
  public readonly description = input<string>('');
  public readonly expanded = input<boolean>(false);
  public readonly disabled = input<boolean>(false);
  public readonly expandedChange = output<boolean>();
}
